<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        title="Order Status Log"
        :large="true"
        :addClose="true"
        @close="close"
        :icon="historyIcon"
    >
      <slot name="load">

      </slot>
      <b-table responsive striped hover :fields="fields" :items="data" show-empty primary-key="id"
               thead-tr-class="headRow" tbody-tr-class="tableRow" emptyText="Geen resultaten">

      </b-table>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import {
    deanDialog,
    featherIconClock,
  } from '@deanone/dean-components';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import { deanDialogBus } from '@/main';
  import axios from 'axios';
  import {BTable} from 'bootstrap-vue';
  import {getDutchLongDateFormat} from "@/mixins/dateWrapper";

  @Component({
    components: {
      DeanNotification,
      deanDialog,
      deanButton,
      BTable,
    },
  })

  export default class ViewOrderStatusLogDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      orderId: string,
    };
    public data: any = [];
    public historyIcon: object = featherIconClock;

    public fields = [
      {key: 'oldStatusName', label: 'Oude status'},
      {key: 'newStatusName', label: 'Nieuwe status'},
      {key: 'userName', label: 'Gebruiker'},
      {key: 'createdAt', label: 'Datum'},
    ];

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    private formatUserDisplay(user: any, partner: any): string {
      const userName = user?.name || '-';
      if (partner?.code && partner?.name) {
        return `${userName} (${partner.code} - ${partner.name})`;
      }
      return userName;
    }

    public created() {
      this.$emit('setLoad', true);
      axios.post('/-/trade/api/order.statusLog.list', {
        orderId: this.payloadData.orderId,
      })
        .then(
        (response) => {
          this.data = response.data.data.map((logEntry: any) => {
            return {
              oldStatusName: logEntry.oldStatus?.name || '-',
              newStatusName: logEntry.newStatus?.name || '',
              userName: this.formatUserDisplay(logEntry.user, logEntry.partner),
              createdAt: getDutchLongDateFormat(logEntry.createdAt),
            };
          });
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveDataModal);
        },
      ).finally(() => {
        this.$emit('setLoad', false);
      });
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

</style>
